// VESSARIQ registered professional catalog UI.
// Browser-only storage covers this customer's selection and filter state; profile details come from the server-rendered section.
const PAGE_SIZE = matchMedia('(max-width:700px)').matches ? 12 : 40;
const PRIMARY = [['category','product_type'],['series','collection'],['texture','texture'],['length','length']];
const EXTRA = [['laceSize','lace_size'],['color','color'],['grade','grade']];
const SPECS = [['texture','texture'],['grade','grade'],['lace','lace'],['laceSize','lace_size'],['density','density'],['color','color'],['unit','unit'],['origin','origin']];
const SORTS = ['default','name','length-up','length-down'];
const STORE_VERSION = 1;

function el(tag, className = '', text) {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text !== undefined) node.textContent = String(text);
  return node;
}
function readCopy(root) {
  try { const data = JSON.parse(root.querySelector('[data-pro-copy]')?.textContent || '{}'); return data && typeof data === 'object' ? data : {}; }
  catch { return {}; }
}
function makeReference() {
  const d = new Date(), pad = n => String(n).padStart(2,'0');
  const bytes = crypto.getRandomValues(new Uint8Array(3));
  const tail = [...bytes].map(b => b.toString(16).padStart(2,'0')).join('').toUpperCase();
  return `VQI-${d.getFullYear()}${pad(d.getMonth()+1)}${pad(d.getDate())}-${tail}`;
}

function prepareNativeProfile(panel, profile) {
  if (!panel || panel.hidden || panel.dataset.proPrefillStarted) return;
  panel.dataset.proPrefillStarted = 'true';
  let attempts = 0;
  const attach = () => {
    const formRoot = panel.querySelector('shopify-forms-embed')?.shadowRoot;
    if (!formRoot) { if (++attempts < 30) setTimeout(attach, 300); return; }
    const filled = new WeakSet();
    let roleStarted = false, roleDone = false;
    const fill = () => {
      for (const [id, value] of [['email',profile.email],['custom#full_name',profile.name],['custom#whatsapp_phone_optional',profile.phone],['custom#instagram_website_optional',profile.instagram]]) {
        const input = formRoot.getElementById(id);
        if (!input || filled.has(input)) continue;
        filled.add(input);
        if (id === 'email') { input.readOnly = true; input.setAttribute('aria-readonly','true'); }
        if (value && (!input.value || (id === 'email' && input.value !== value))) {
          Object.getOwnPropertyDescriptor(HTMLInputElement.prototype,'value').set.call(input,value);
          input.dispatchEvent(new Event('input',{bubbles:true,composed:true}));
          input.dispatchEvent(new Event('change',{bubbles:true,composed:true}));
        }
      }
      if (!profile.role || roleDone) return;
      const value = formRoot.getElementById('custom#business_type-selector-value');
      if (value?.textContent.trim()) { roleDone = true; return; }
      const button = formRoot.querySelector('button[aria-labelledby*="custom#business_type-selector-label"]');
      if (button && !roleStarted) { roleStarted = true; button.click(); }
      const option = [...formRoot.querySelectorAll('[role="option"]')].find(e=>e.textContent.trim()===profile.role);
      if (option) { roleDone = true; option.click(); }
    };
    new MutationObserver(fill).observe(formRoot,{childList:true,subtree:true});
    fill();
  };
  attach();
}

async function init(root) {
  if (!root || root.dataset.proInit) return;
  root.dataset.proInit = 'true';
  const copy = readCopy(root);
  const t = (key, vars = {}) => Object.entries(vars).reduce((text,[k,v]) => text.split(`{${k}}`).join(String(v)), copy[key] ?? key);
  const $ = selector => root.querySelector(selector);
  const $$ = selector => [...root.querySelectorAll(selector)];
  const ds = root.dataset;
  const profile = {name:ds.customerName||'',role:ds.customerRole||'',email:ds.customerEmail||'',phone:ds.customerPhone||'',instagram:ds.customerInstagram||''};
  const workspace = $('[data-pro-workspace]');
  const dialog = $('[data-pro-inquiry]');
  const storeKey = ds.customerId && ds.ready === 'true' && workspace ? `vq-pro-catalog:${ds.customerId}` : '';
  const state = {items:[],filters:{},query:'',sort:'default',page:0,selection:{},drafts:{},reference:makeReference(),message:'',tooLong:false};
  const lengthLabel = value => `${Number(value)} ${t('inch')}`;
  const valueLabel = (key, value) => key === 'length' ? lengthLabel(value) : String(value);

  bindProfileToggle();
  bindDownload();
  reservePreviewBar();
  prepareNativeProfile($('[data-pro-profile-panel]'),profile);

  let core;
  try { core = await import(new URL(ds.coreUrl, document.baseURI).href); }
  catch (error) { console.error('[vq-pro] core module failed to load', error); return; }
  const {FILTER_KEYS,filterItems,facetValues,matches,parseQuantity,validSelection,composeInquiry,contactLinks} = core;
  const inquiryCopy = {greeting:t('greeting'),introduceName:t('introduce_name'),introduceRole:t('introduce_role'),quoteIntro:t('quote_intro'),quoteAsk:t('quote_ask'),generalInquiry:t('general_inquiry'),inch:t('inch'),quantity:t('quantity')};

  bindDialog();
  updateDock();
  updateLinks();
  if (workspace) loadCatalog();

  function bindDownload() {
    const link = $('[data-pro-download]');
    if (!link) return;
    let pending = false;
    link.addEventListener('click', async event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
      event.preventDefault();
      if (pending) return;
      pending = true;
      const label = link.textContent;
      link.textContent = t('preparing_download');
      link.setAttribute('aria-busy','true');
      const help = $('[data-pro-download-help]'), status = $('[data-pro-download-status]');
      try {
        const response = await fetch(link.href,{mode:'cors',credentials:'omit'});
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const blob = await response.blob();
        const magic = new Uint8Array(await blob.slice(0,4).arrayBuffer());
        if (blob.size < 1000 || magic[0] !== 80 || magic[1] !== 75 || magic[2] !== 3 || magic[3] !== 4) throw new Error('Invalid workbook');
        const url = URL.createObjectURL(blob), anchor = document.createElement('a');
        anchor.href = url; anchor.download = link.getAttribute('download');
        document.body.append(anchor); anchor.click(); anchor.remove();
        setTimeout(()=>URL.revokeObjectURL(url),60000);
        if (status) status.textContent = t('download_fallback');
      } catch (error) {
        console.error('[vq-pro] catalog download',error);
        if (status) status.textContent = t('download_error');
      } finally {
        if (help) help.hidden = false;
        link.textContent = label; link.removeAttribute('aria-busy'); pending = false;
      }
    });
  }

  // Keep the contact dock accessible above Shopify's draft-only preview bar.
  function reservePreviewBar() {
    let attempts = 0;
    const attach = () => {
      const bar = document.getElementById('PBarNextFrame');
      if (!bar) { if (++attempts < 20) setTimeout(attach, 500); return; }
      const adjust = () => {
        const rect = bar.getBoundingClientRect();
        const offset = rect.height > 0 && rect.width > innerWidth / 2 && rect.bottom >= innerHeight - 1
          ? (rect.height >= 160 ? 64 : Math.max(0, innerHeight - rect.top)) : 0;
        root.style.setProperty('--pro-preview-bottom', `${offset}px`);
      };
      new ResizeObserver(adjust).observe(bar);
      window.addEventListener('resize', adjust);
      adjust();
    };
    attach();
  }

  // ---- Profile panel (native Shopify Forms block; nothing is saved by this script) ----
  function bindProfileToggle() {
    const button = $('[data-pro-edit-profile]'), panel = $('[data-pro-profile-panel]');
    if (!button || !panel) return;
    button.setAttribute('aria-expanded', String(!panel.hidden));
    button.addEventListener('click', () => {
      panel.hidden = !panel.hidden;
      button.setAttribute('aria-expanded', String(!panel.hidden));
      if (!panel.hidden) { prepareNativeProfile(panel,profile); panel.scrollIntoView({block:'start'}); panel.querySelector('input,select,textarea,button,a[href]')?.focus({preventScroll:true}); }
    });
  }

  // ---- Persistence (selection + filter state only) ----
  function save() {
    if (!storeKey) return;
    try { localStorage.setItem(storeKey, JSON.stringify({v:STORE_VERSION,selection:state.selection,filters:state.filters,query:state.query,sort:state.sort,page:state.page})); }
    catch {}
  }
  function restore() {
    if (!storeKey) return;
    let saved;
    try { saved = JSON.parse(localStorage.getItem(storeKey) || 'null'); } catch { saved = null; }
    if (!saved || saved.v !== STORE_VERSION) return;
    state.selection = validSelection(saved.selection, state.items);
    if (saved.filters && typeof saved.filters === 'object') for (const key of FILTER_KEYS) {
      const value = saved.filters[key];
      if (value !== undefined && value !== '' && facetValues(state.items,key).includes(String(value))) state.filters[key] = String(value);
    }
    if (typeof saved.query === 'string') state.query = saved.query.slice(0,200);
    if (SORTS.includes(saved.sort)) state.sort = saved.sort;
    if (Number.isInteger(saved.page) && saved.page >= 0) state.page = saved.page;
  }

  // ---- Catalog loading ----
  async function loadCatalog() {
    const results = $('[data-pro-results]');
    results.textContent = t('loading');
    $('[data-pro-retry]')?.remove();
    try {
      const response = await fetch(ds.catalogUrl);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data = await response.json();
      if (!Array.isArray(data?.items)) throw new Error('Invalid catalog');
      state.items = data.items.filter(item => item && typeof item.id === 'string' && typeof item.title === 'string');
    } catch (error) {
      console.error('[vq-pro] catalog failed to load', error);
      results.textContent = t('load_error');
      const retry = el('button','',t('retry'));
      retry.type = 'button'; retry.dataset.proRetry = '';
      retry.addEventListener('click', loadCatalog);
      results.after(retry);
      return;
    }
    restore();
    const search = $('[data-pro-search]');
    if (search) search.value = state.query;
    buildFilters();
    bindWorkspace();
    render();
    updateDock();
    updateLinks();
  }

  // ---- Custom filters: <details> + ARIA listbox ----
  const filterUI = {};
  function buildFilters() {
    const build = ([key,labelKey], container) => {
      if (!container) return;
      const details = el('details','vq-pro__filter'); details.dataset.proFilter = key;
      const summary = el('summary'); summary.setAttribute('aria-haspopup','listbox');
      const labelId = `VqProFilterLabel-${key}`;
      const head = el('span'), label = el('span','vq-pro__filter-label',t(labelKey)), value = el('span','vq-pro__filter-value');
      label.id = labelId; head.append(label,value); summary.append(head);
      const list = el('div','vq-pro__filter-options');
      list.setAttribute('role','listbox'); list.setAttribute('aria-labelledby',labelId); list.id = `VqProFilterList-${key}`;
      summary.setAttribute('aria-controls',list.id);
      const options = ['',...facetValues(state.items,key)].map(optionValue => {
        const option = el('button','vq-pro__option');
        option.type = 'button'; option.tabIndex = -1; option.setAttribute('role','option'); option.dataset.value = optionValue;
        const count = el('span','vq-pro__option-count');
        option.append(el('span','',optionValue ? valueLabel(key,optionValue) : t('all')), count);
        option.addEventListener('click', () => choose(key, optionValue));
        list.append(option);
        return {option,count,value:optionValue};
      });
      details.append(summary,list);
      container.append(details);
      filterUI[key] = {details,summary,list,value,options};
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        Object.values(filterUI).forEach(ui => { if (ui.details !== details) ui.details.open = false; });
      });
      summary.addEventListener('keydown', event => {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        event.preventDefault(); details.open = true; focusOption(key, 'selected');
      });
      list.addEventListener('keydown', event => listKeys(key, event));
    };
    PRIMARY.forEach(spec => build(spec, $('[data-pro-primary-filters]')));
    EXTRA.forEach(spec => build(spec, $('[data-pro-extra-filters]')));
    document.addEventListener('pointerdown', event => {
      Object.values(filterUI).forEach(ui => { if (ui.details.open && !ui.details.contains(event.target)) ui.details.open = false; });
    });
  }
  function enabledOptions(key) { return filterUI[key].options.filter(o => !o.option.disabled).map(o => o.option); }
  function focusOption(key, where) {
    const list = enabledOptions(key); if (!list.length) return;
    const current = list.indexOf(document.activeElement);
    const selected = list.findIndex(o => o.getAttribute('aria-selected') === 'true');
    const index = where === 'selected' ? Math.max(selected,0) : where === 'first' ? 0 : where === 'last' ? list.length-1
      : Math.min(list.length-1, Math.max(0, (current < 0 ? Math.max(selected,0) : current) + where));
    list.forEach((o,i) => { o.tabIndex = i === index ? 0 : -1; });
    list[index].focus();
  }
  function listKeys(key, event) {
    const ui = filterUI[key];
    const moves = {ArrowDown:1,ArrowUp:-1,Home:'first',End:'last',PageDown:5,PageUp:-5};
    if (event.key in moves) { event.preventDefault(); focusOption(key, moves[event.key]); return; }
    if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); ui.details.open = false; ui.summary.focus(); return; }
    if (event.key === 'Tab') { ui.details.open = false; return; }
    if (event.key.length === 1 && /\S/.test(event.key) && !event.ctrlKey && !event.metaKey && !event.altKey) {
      const list = enabledOptions(key), start = list.indexOf(document.activeElement);
      const char = event.key.toLowerCase();
      for (let step = 1; step <= list.length; step++) {
        const option = list[(start + step) % list.length];
        if (option.textContent.trim().toLowerCase().startsWith(char)) { list.forEach(o => { o.tabIndex = -1; }); option.tabIndex = 0; option.focus(); break; }
      }
    }
  }
  function choose(key, value) {
    if (value) state.filters[key] = value; else delete state.filters[key];
    state.page = 0;
    const ui = filterUI[key];
    ui.details.open = false;
    render(); save();
    ui.summary.focus();
  }
  function renderFilters() {
    for (const [key,ui] of Object.entries(filterUI)) {
      const pool = state.items.filter(item => matches(item, state.filters, state.query, key));
      const counts = new Map();
      pool.forEach(item => { const v = String(item[key] ?? ''); if (v) counts.set(v,(counts.get(v)||0)+1); });
      const active = state.filters[key] || '';
      let available = 0;
      ui.options.forEach(({option,count,value}) => {
        const n = value ? (counts.get(value)||0) : pool.length;
        const selected = value === active;
        if (value && n) available++;
        count.textContent = String(n);
        option.disabled = !selected && value !== '' && n === 0;
        option.setAttribute('aria-selected', String(selected));
        option.tabIndex = selected ? 0 : -1;
      });
      ui.value.textContent = active ? valueLabel(key,active) : t('all');
      ui.summary.dataset.active = String(Boolean(active));
      // Secondary specifications only appear when the current product mix actually uses them.
      if (EXTRA.some(([k]) => k === key)) ui.details.hidden = !active && available === 0;
    }
  }

  // ---- Workspace events ----
  function bindWorkspace() {
    const search = $('[data-pro-search]');
    let timer;
    search?.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(() => { state.query = search.value.slice(0,200); state.page = 0; render(); save(); }, 150);
    });
    $('[data-pro-clear-filters]')?.addEventListener('click', () => {
      state.filters = {}; state.query = ''; state.page = 0;
      if (search) search.value = '';
      render(); save();
    });
    $$('[data-pro-sort]').forEach(button => button.addEventListener('click', () => {
      const kind = button.dataset.proSort;
      if (kind === 'name') state.sort = state.sort === 'name' ? 'default' : 'name';
      else state.sort = state.sort === 'length-up' ? 'length-down' : state.sort === 'length-down' ? 'default' : 'length-up';
      state.page = 0; render(); save();
    }));
    $('[data-pro-prev]')?.addEventListener('click', () => goPage(state.page - 1));
    $('[data-pro-next]')?.addEventListener('click', () => goPage(state.page + 1));
    const rows = $('[data-pro-rows]');
    rows?.addEventListener('change', event => {
      const input = event.target.closest('input[type=checkbox][data-pro-pick]');
      if (!input) return;
      const id = input.dataset.proPick;
      if (input.checked) state.selection[id] = ''; else { delete state.selection[id]; delete state.drafts[id]; }
      const item = state.items.find(x => x.id === id);
      const row = input.closest('tr');
      if (item && row) { const next = rowFor(item); row.replaceWith(next); next.querySelector('[data-pro-pick]')?.focus(); }
      selectionChanged();
    });
    rows?.addEventListener('input', event => {
      const input = event.target.closest('input[data-pro-qty]');
      if (input) setQuantity(input.dataset.proQty, input);
    });
  }
  function goPage(page) {
    state.page = page; render(); save();
    const wrap = $('.vq-pro__table-wrap');
    if (wrap) { wrap.scrollTop = 0; if (wrap.getBoundingClientRect().top < 0) wrap.scrollIntoView({block:'start'}); }
  }
  function setQuantity(id, input) {
    if (!Object.hasOwn(state.selection, id)) return;
    const parsed = parseQuantity(input.value);
    const error = input.closest('td')?.querySelector('[data-pro-qty-error]');
    if (parsed === null) {
      state.drafts[id] = input.value; state.selection[id] = '';
      input.setAttribute('aria-invalid','true');
      if (error) { error.textContent = t('quantity_invalid'); error.hidden = false; }
    } else {
      delete state.drafts[id]; state.selection[id] = parsed;
      input.removeAttribute('aria-invalid');
      if (error) { error.textContent = ''; error.hidden = true; }
    }
    selectionChanged();
  }
  function selectionChanged() { save(); updateDock(); updateLinks(); }

  // ---- Table ----
  function rowFor(item) {
    const selected = Object.hasOwn(state.selection, item.id);
    const safeId = item.id.replace(/[^\w-]/g,'_');
    const tr = el('tr'); tr.dataset.selected = String(selected);
    const pickCell = el('td'), pickLabel = el('label','vq-pro__check'), pick = el('input');
    pick.type = 'checkbox'; pick.checked = selected; pick.dataset.proPick = item.id;
    pick.setAttribute('aria-label', `${t('select')}: ${item.title} (${item.id})`);
    pickLabel.append(pick); pickCell.append(pickLabel);
    const nameCell = el('td');
    nameCell.append(el('div','vq-pro__product-name',item.title), el('p','vq-pro__code',item.id));
    const specs = SPECS.filter(([key]) => item[key]);
    if (specs.length) {
      const details = el('details','vq-pro__specs'), dl = el('dl');
      details.append(el('summary','',t('specifications')));
      specs.forEach(([key,labelKey]) => dl.append(el('dt','',t(labelKey)), el('dd','',item[key])));
      details.append(dl); nameCell.append(details);
    }
    const seriesCell = el('td','',item.series || '');
    const lengthCell = el('td','',Number.isFinite(Number(item.length)) && item.length !== '' ? lengthLabel(item.length) : '');
    const qtyCell = el('td');
    if (selected) {
      const wrap = el('div','vq-pro__quantity'), label = el('label','',t('quantity')), input = el('input');
      input.id = `VqProQty-${safeId}`; label.htmlFor = input.id;
      input.type = 'text'; input.inputMode = 'numeric'; input.autocomplete = 'off'; input.maxLength = 6;
      input.dataset.proQty = item.id;
      const draft = state.drafts[item.id];
      input.value = draft ?? state.selection[item.id] ?? '';
      const error = el('p','vq-pro__code'); error.dataset.proQtyError = ''; error.id = `VqProQtyError-${safeId}`; error.setAttribute('aria-live','polite');
      input.setAttribute('aria-describedby', error.id);
      if (draft !== undefined) { input.setAttribute('aria-invalid','true'); error.textContent = t('quantity_invalid'); } else error.hidden = true;
      wrap.append(label,input,error); qtyCell.append(wrap);
    } else qtyCell.append(el('span','vq-pro__quantity-placeholder',t('add_first')));
    tr.append(pickCell,nameCell,seriesCell,lengthCell,qtyCell);
    return tr;
  }
  function render() {
    const result = filterItems(state.items, state.filters, state.query, state.sort);
    const pages = Math.max(1, Math.ceil(result.length / PAGE_SIZE));
    state.page = Math.min(Math.max(0, state.page), pages - 1);
    const start = state.page * PAGE_SIZE, slice = result.slice(start, start + PAGE_SIZE);
    const rows = $('[data-pro-rows]');
    const frag = document.createDocumentFragment();
    slice.forEach(item => frag.append(rowFor(item)));
    rows?.replaceChildren(frag);
    const empty = $('[data-pro-empty]'); if (empty) empty.hidden = result.length > 0;
    $('[data-pro-results]').textContent = t('result_count', {count:result.length});
    const pageLabel = $('[data-pro-page]');
    if (pageLabel) pageLabel.textContent = result.length ? t('showing', {start:start+1,end:start+slice.length,total:result.length}) : '';
    const prev = $('[data-pro-prev]'), next = $('[data-pro-next]');
    if (prev) prev.disabled = state.page === 0;
    if (next) next.disabled = state.page >= pages - 1;
    $$('[data-pro-sort]').forEach(button => {
      const kind = button.dataset.proSort, th = button.closest('th');
      const sort = kind === 'name' ? (state.sort === 'name' ? 'ascending' : 'none')
        : state.sort === 'length-up' ? 'ascending' : state.sort === 'length-down' ? 'descending' : 'none';
      th?.setAttribute('aria-sort', sort);
    });
    const clear = $('[data-pro-clear-filters]');
    if (clear) clear.disabled = !state.query && !Object.keys(state.filters).length;
    renderFilters();
  }

  // ---- Dock + contact links ----
  function selectedCount() { return Object.keys(state.selection).length; }
  function updateDock() {
    const button = $('[data-pro-open-inquiry]');
    if (!button) return;
    const count = selectedCount();
    button.textContent = count ? `${t('selected_count',{count})} · ${t('view_inquiry')}` : t('general_contact');
  }
  function updateLinks() {
    const note = $('[data-pro-note]')?.value || '';
    state.message = composeInquiry({profile,selection:state.selection,items:state.items,note,reference:state.reference,copy:inquiryCopy});
    const links = contactLinks(state.message, state.reference);
    state.tooLong = links.tooLong;
    $$('[data-pro-whatsapp]').forEach(a => { a.href = links.whatsapp; });
    $$('[data-pro-gmail]').forEach(a => { a.href = links.gmail; });
    $$('[data-pro-mailto]').forEach(a => { a.href = links.mailto; });
    const longNote = $('[data-pro-long-message]'), fullLabel = $('[data-pro-full-message-label]'), full = $('[data-pro-full-message]');
    if (longNote) longNote.hidden = !links.tooLong;
    if (links.tooLong || (fullLabel && !fullLabel.hidden)) { if (full) full.value = state.message; }
    if (fullLabel) fullLabel.hidden = !links.tooLong && !fullLabel.dataset.forced;
  }

  // ---- Inquiry dialog (native <dialog>; links only prepare the message, the customer sends it) ----
  function renderSelection() {
    const list = $('[data-pro-selection]');
    if (!list) return;
    const chosen = state.items.filter(item => Object.hasOwn(state.selection, item.id));
    if (!chosen.length) { list.replaceChildren(el('li','',t('empty_inquiry'))); return; }
    list.replaceChildren(...chosen.map(item => {
      const li = el('li');
      const meta = [item.id];
      if (item.length !== '' && item.length !== undefined) meta.push(lengthLabel(item.length));
      if (state.selection[item.id]) meta.push(`${t('quantity')}: ${state.selection[item.id]}`);
      const remove = el('button','vq-pro__copy',t('remove'));
      remove.type = 'button'; remove.dataset.proRemove = item.id;
      remove.setAttribute('aria-label', `${t('remove')}: ${item.title} (${item.id})`);
      li.append(el('div','vq-pro__product-name',item.title), el('p','vq-pro__code',meta.join(' · ')), remove);
      return li;
    }));
  }
  function bindDialog() {
    if (!dialog) return;
    const opener = $('[data-pro-open-inquiry]');
    let lastFocus = null;
    opener?.addEventListener('click', () => {
      lastFocus = document.activeElement;
      renderSelection(); updateLinks();
      if (typeof dialog.showModal === 'function') { if (!dialog.open) dialog.showModal(); } else dialog.setAttribute('open','');
    });
    $$('[data-pro-whatsapp],[data-pro-gmail],[data-pro-mailto]').forEach(link=>link.addEventListener('click',event=>{
      if (state.tooLong && !dialog.contains(link)) { event.preventDefault(); opener?.click(); }
    }));
    const close = () => { if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open'); };
    $('[data-pro-close-inquiry]')?.addEventListener('click', close);
    dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
    dialog.addEventListener('close', () => { if (lastFocus && document.contains(lastFocus)) lastFocus.focus(); });
    $('[data-pro-note]')?.addEventListener('input', updateLinks);
    $('[data-pro-selection]')?.addEventListener('click', event => {
      const button = event.target.closest('[data-pro-remove]');
      if (!button) return;
      const id = button.dataset.proRemove;
      const buttons = $$('[data-pro-remove]'), index = buttons.indexOf(button);
      delete state.selection[id]; delete state.drafts[id];
      renderSelection(); if (state.items.length && workspace) render();
      selectionChanged();
      const remaining = $$('[data-pro-remove]');
      (remaining[Math.min(index, remaining.length-1)] || $('[data-pro-close-inquiry]'))?.focus();
    });
    $('[data-pro-clear-selection]')?.addEventListener('click', () => {
      state.selection = {}; state.drafts = {}; state.reference = makeReference();
      renderSelection(); if (state.items.length && workspace) render();
      selectionChanged();
    });
    const copyButton = $('[data-pro-copy-inquiry]');
    const copyLabel = copyButton?.textContent;
    let copyTimer;
    copyButton?.addEventListener('click', async () => {
      updateLinks();
      clearTimeout(copyTimer);
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(state.message);
        copyButton.textContent = t('copied');
      } catch {
        const fullLabel = $('[data-pro-full-message-label]'), full = $('[data-pro-full-message]');
        if (fullLabel && full) { fullLabel.dataset.forced = 'true'; fullLabel.hidden = false; full.value = state.message; full.focus(); full.select(); }
        copyButton.textContent = t('copy_failed');
      }
      copyTimer = setTimeout(() => { copyButton.textContent = copyLabel; }, 2500);
    });
  }
}

const boot = () => document.querySelectorAll('.vq-pro[data-core-url]').forEach(root => { init(root); });
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
document.addEventListener('shopify:section:load', event => { event.target?.querySelectorAll?.('.vq-pro[data-core-url]').forEach(root => { init(root); }); });
